import { Component } from '@angular/core';
import { cookiePolicyData } from '../../../data/cookie-policy.data';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-cookie-policy',
  standalone: false,
  
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.css'
})
export class CookiePolicyComponent extends BaseComponent {
  cookiePolicy = cookiePolicyData;
}
